import { ErrorStateSlice } from "./types";

export const initialState: ErrorStateSlice = {
  error: {
    type: null,
    message: null,
  },
};
